// extracted by mini-css-extract-plugin
export default {"notification_float":"notification_notification_float__OrisL","notification":"notification_notification__SNYvU","posreal":"notification_posreal__zDQ7H"};